export default "__VITE_ASSET__061bb0ae__"